module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showPreloaderIcon ? 'preloader show' : 'preloader',
    style: (_vm.display ? 'display: table' : 'display: none')
  }, [_c('div', {
    staticClass: "preloader-center"
  }, [_c('div', {
    staticClass: "preloader-icon"
  }, [_c('svg', {
    attrs: {
      "width": "34",
      "height": "38",
      "viewBox": "0 0 34 38"
    }
  }, [_c('path', {
    staticClass: "preloader-path",
    attrs: {
      "stroke-dashoffset": "0",
      "d": "M29.437 8.114L19.35 2.132c-1.473-.86-3.207-.86-4.68 0L4.153 8.114C2.68 8.974 1.5 10.56 1.5 12.28v11.964c0 1.718 1.22 3.306 2.69 4.165l10.404 5.98c1.47.86 3.362.86 4.834 0l9.97-5.98c1.472-.86 2.102-2.45 2.102-4.168V12.28c0-1.72-.59-3.306-2.063-4.166z"
    }
  }, [_c('animate', {
    attrs: {
      "attributeType": "XML",
      "attributeName": "stroke-dashoffset",
      "from": "0",
      "to": "102px",
      "dur": "1s",
      "repeatCount": "indefinite"
    }
  })])])]), _vm._v(" "), _c('div', {
    class: _vm.showPreloaderInfos ? 'informations show' : 'informations'
  }, [(_vm.mobile) ? _c('div', {
    staticClass: "mobile-infos"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "desktop-infos"
  }, [_c('div', {
    staticClass: "info move col"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/move-mouse.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Move mouse to rotate camera")])]), _vm._v(" "), _c('div', {
    staticClass: "info spacebar col"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/spacebar.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Press spacebar to slow down")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info landscape col"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/smarthphone-orientation.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Turn your mobile to landscape mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info touch col"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/touch.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Touch the screen to slow down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-187cc40f!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Preloader.vue
// module id = 179
// module chunks = 2